import type { Filter } from '../../../../generated/frontend'
import type {
  FilterItemIntersection,
  NeedsBasedAnswerOptionExtended,
} from '../../../../shared/types'
import { getFilterAttributeValue } from '../components/Filter/utils'

export const findCommonBasicFilter = ({
  filterOptions,
  basicFilters,
  onOptionCallback,
}: {
  filterOptions: NeedsBasedAnswerOptionExtended[]
  basicFilters: Filter[]
  onOptionCallback: OnOptionsCallback
}) => {
  filterOptions.forEach((option) => {
    const commonBasicFilter = basicFilters.find((filter) => {
      if (
        filter.attributeGroup === option.attributeGroup &&
        filter.externalId === option.externalId
      ) {
        return filter.filterItems.find((item: FilterItemIntersection) => {
          const optionVal = getFilterAttributeValue({
            valueBool: option?.valueBool,
            valueStr: option?.valueStr,
            from: option?.from,
            to: option?.to,
          })

          const itemVal = getFilterAttributeValue({
            valueBool: item?.valueBool,
            valueStr: item?.valueStr,
            from: item?.from,
            to: item?.to,
          })

          if (item?.options) {
            return (
              item.code === option.code &&
              item?.options.find(
                (itemOption) =>
                  optionVal === getFilterAttributeValue({ valueBool: itemOption.optionValueBool })
              )
            )
          }

          return item.code === option.code && itemVal === optionVal
        })
      }
    })

    onOptionCallback({ commonBasicFilter, option })
  })
}

type OnOptionsCallbackArgs = {
  commonBasicFilter?: Filter
  option: NeedsBasedAnswerOptionExtended
}

type OnOptionsCallback = ({ commonBasicFilter, option }: OnOptionsCallbackArgs) => void
